<template>
  <main class="main-content mt-0">
    <div
      class="page-header align-items-start min-vh-50 pt-5 pb-11 m-3 border-radius-lg"
      style="background-image: url('https://dicora.com/wp-content/uploads/2023/01/an-scaled.jpg'); background-position: top;"
    >
      <span class="mask bg-gradient-dark opacity-6"></span>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-5 text-center mx-auto">
            <h1 class="text-white mb-2 mt-5">Bienvenido</h1>
            <p
              class="text-lead text-white"
            >Preparamos algo asombroso para ti.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
        <div class="col-xl-4 col-lg-5 col-md-7 mx-auto">
          <div class="card z-index-0">
            <div class="card-header text-center pt-4">
              <img :src="logo" width="150" style="margin-bottom: 20px;">
              <h5>Establecer contraseña</h5>
            </div>
            <div class="card-body">
              <form role="form" @submit.prevent="">
                <argon-input type="password" placeholder="Contraseña" aria-label="Password" v-model="password"/>
                <argon-input type="password" placeholder="Confirmar contraseña" aria-label="Password" v-model="cpassword"/>
                <!-- <argon-checkbox checked>
                  <label class="form-check-label" for="flexCheckDefault">
                    I agree the
                    <a
                      href="javascript:;"
                      class="text-dark font-weight-bolder"
                    >Terms and Conditions</a>
                  </label>
                </argon-checkbox> -->
                <div class="text-center">
                  <argon-button fullWidth color="dark" variant="gradient" class="my-4 mb-2" @click="setPassword">Establecer credenciales</argon-button>
                </div>
                <p class="text-sm mt-3 mb-0">
                  ¿Ya tiene sus credenciales?
                  <a
                    href="/signin"
                    class="text-dark font-weight-bolder"
                  >Iniciar sesión</a>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <app-footer />
</template>

<script>
import AppFooter from "@/examples/PageLayout/Footer.vue";
import ArgonInput from "@/components/ArgonInput.vue";
//import ArgonCheckbox from "@/components/ArgonCheckbox.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import logo from "@/assets/img/dicora.png";
import axios from 'axios';
const body = document.getElementsByTagName("body")[0];

export default {
  name: "signin",
  components: {
    AppFooter,
    ArgonInput,
    //ArgonCheckbox,
    ArgonButton,
  },
  data(){
    return{
      logo,
      password:null,
      cpassword:null
    }
  },
  methods:{
    setPassword(){
      if(this.password==this.cpassword){
        axios.post(this.$EndPoint+'users/update-pwd/'+this.$route.params.id,{
          password:this.password
        })
        .then(result=>{
          localStorage.setItem('AccountId', result.data.AccountId);
          localStorage.setItem('Email', result.data.Email);
          localStorage.setItem('Name', result.data.Name);
          localStorage.setItem('Token', result.data.Token);
          localStorage.setItem('IsLoggedIn',true);
          this.$router.push('/dashboard')
        })
        .catch((error)=>{
          console.log(error);
        })
      }else{
        this.$swal({
          title: 'Credenciales incorrectas',
          icon:'error',
          color:'#b4243a',
          confirmButtonText:'Intentar nuevamente',
          buttonsStyling:false,
          customClass:{
            confirmButton:'btn btn-danger'
          },
          confirmButtonColor:'#b4243a',
          showClass: {
            popup: 'animate__animated animate__fadeInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp'
          }
        })
      }
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>
